import { Component } from 'preact';
import { Link, withRouter } from 'react-router-dom';
import Countdown from 'react-countdown-now';
import MetaTags from 'react-meta-tags';

import { USER_STATUS } from '../../enums/UserStatus';

import Layout from '../../components/Layout';
import SecuredPaymentInfo from '../../components/blocks/raffleForm/SecuredPaymentInfo';
import CountdownTimerRenderer from '../../components/countdown/CountdownTimerRenderer';
import Promo from '../../components/promo/Promo';

import RouteHelper from '../../helpers/RouteHelper';

import ThankYouCountdownTimerStyle from '../../components/countdown/styles/ThankYouCountdownTimerStyle.scss';
import style from './styles.scss';

@withRouter
class ThankYouPage extends Component {
	render() {
		const { route, match, location, registrationId, raffleClosedAt, suggestedShopId } = this.props;

		const regId = registrationId || match.params.registrationId;

		const isGuest = match.params.userStatus === USER_STATUS.GUEST;
		const raffleDeadline = Date.parse(raffleClosedAt) || match.params.raffleClosedAt && match.params.raffleClosedAt * 1000;

		return (
			<Layout {...{ route, location }}>
				<MetaTags>
					<title>{route.metaTitle}</title>
					<meta name="description" content="" />
				</MetaTags>
				<SecuredPaymentInfo />
				<div className={'mb-5'}>
					<div className={style['complete-step-container']}>
						<div className={style['complete-step']}>
							<i className={`fa fa-check-circle ${style['green-check']}`} />
							<h2 className={style['thank-you']}>Thank you!</h2>
							{regId && (
								<span className={style['your-application']}>
									Your application <span className={style.id}>#{regId}</span> was created
								</span>
							)}

							{raffleDeadline && (
								<div className={style['time-remaining']}>
									<h3>raffle registration ends in</h3>
									<Countdown
										renderer={CountdownTimerRenderer}
										withDividers
										style={ThankYouCountdownTimerStyle}
										date={raffleDeadline}
									/>
								</div>
							)}

							<Link className={style['see-other-raffles']} to={RouteHelper.getUrl('/')}>
								See other raffles <span className={style.arrow} />
							</Link>
							{isGuest && (
								<div className={style.promoWrapper}>
									<Promo suggestedShopId={suggestedShopId} />
								</div>
							)}
						</div>
						<div className={style['additional-information']}>
							<h2>Check out limited editions on the eshop</h2>
							<a className={style['go-button']} href={RouteHelper.getExternalUrl('/footshop')}>
								Go to eshop <span className={style.arrow} />
							</a>
						</div>
					</div>
				</div>
			</Layout>
		);
	}
}

export default ThankYouPage;



// WEBPACK FOOTER //
// ./routes/thankYou/component.js